import styled from 'styled-components';

/**
 * The white card the client modal actually is, full width of the wizard.
 * It used to sit in a phone-bezel mock; the frame ate half the modal's width
 * and told the reader nothing the card itself does not.
 */
export const PreviewCard = styled.div`
  background: ${({ theme }) => theme.white};
  border-radius: 24px;
  padding: 24px;
  border: ${({ theme }) => theme.borders.border1};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
`;
